<template>
  <form @submit.prevent="applyFilter">
    <div class="font-weight-bold">Filter by:</div>
    <div class="form-row">
      <!-- Search filter -->
      <div class="form-group col-sm">
        <label for="search"> Question </label>
        <input
          type="text"
          class="form-control"
          id="search"
          name="search"
          placeholder="Search for a word..."
          v-model="form.search"
        />
      </div>

      <!-- Theme filter -->
      <div class="form-group col-sm">
        <label for="theme"> Theme </label>
        <select
          name="theme"
          id="theme"
          class="form-control"
          v-model="form.theme"
        >
          <option value="">All</option>
          <option
            v-for="(theme, index) in themes"
            :key="index"
            v-bind:value="theme"
          >
            {{ theme }}
          </option>
        </select>
      </div>

      <!-- Type filter -->
      <div class="form-group col-sm">
        <label for="type"> Type </label>
        <select name="type" id="type" class="form-control" v-model="form.type">
          <option value="">All</option>
          <option
            v-for="(type, index) in types"
            :key="index"
            v-bind:value="type"
          >
            {{ type }}
          </option>
        </select>
      </div>

      <!-- Confirmed or Tmp filter -->
      <!-- <div class="form-group col-sm">
        <label for="custom"> Confirmé ou Tmp </label>
        <select
          name="custom"
          id="custom"
          class="form-control"
          v-model="form.custom"
        >
          <option value="">Toutes</option>
          <option value="default">Par défaut uniquement</option>
          <option value="custom">Personnalisées uniquement</option>
        </select>
      </div> -->

      <!-- Level filter -->
      <div class="form-group col-sm">
        <label for="level"> Difficulty </label>
        <select
          name="level"
          id="level"
          class="form-control text-capitalize"
          v-model="form.level"
        >
          <option value="">All</option>
          <option
            v-for="(level, index) in levels"
            :key="index"
            v-bind:value="level"
          >
            {{ level }}
          </option>
        </select>
      </div>

      <!-- Audio filter -->
      <div class="form-group col-sm">
        <label for="audio"> With audio </label>
        <select
          name="audio"
          id="audio"
          class="form-control"
          v-model="form.audio"
        >
          <option value="">All</option>
          <option value="with">Yes</option>
          <option value="without">No</option>
        </select>
      </div>

      <!-- Actions -->
      <div class="form-group col-sm">
        <label for=""> &nbsp; </label>
        <div class="d-flex justify-content-center align-items-center">
          <button class="btn w-100 btn-success mr-2" type="submit">
            Apply
          </button>
          <button
            class="btn w-100 btn-outline-danger"
            @click.prevent="resetFilter()"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'QuestionsListFilters',
    props: {
      filters: {
        type: Object,
        default: null,
      },
      themes: {
        type: Array,
        default: () => [],
      },
      types: {
        type: Array,
        default: () => [],
      },
      levels: {
        type: Array,
        default: () => [],
      },
    },
    mounted() {
      this.initForm()
    },
    data() {
      return {
        form: {
          search: '',
          theme: '',
          type: '',
          custom: '',
          level: '',
          audio: '',
        },
      }
    },
    computed: {},
    methods: {
      applyFilter() {
        this.$emit('apply', this.form)
      },
      resetFilter() {
        this.$emit('reset')
        this.initForm()
      },
      initForm() {
        this.form = {
          search: '',
          theme: '',
          type: '',
          custom: '',
          level: '',
          audio: '',
        }
      },
    },
  }
</script>
